import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../../components/layout/PublicLayout';
import { subscribeAPI } from '../../utils/api';


// ─── COOKIE BANNER ───────────────────────────────────────────────────────────
function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookiesAccepted')) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      width: '100%',
      background: '#111',
      color: '#fff',
      padding: '15px',
      textAlign: 'center',
      zIndex: 9999
    }}>
      This website uses cookies and Google AdSense to improve your experience.
      <button onClick={accept} style={{
        marginLeft: 15,
        padding: '8px 16px',
        background: '#c0392b',
        border: 'none',
        color: '#fff',
        cursor: 'pointer'
      }}>
        Accept
      </button>
    </div>
  );
}


// ─── ABOUT PAGE ──────────────────────────────────────────────────────────────
export function AboutPage() {
  return (
    <PublicLayout>
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '60px 20px' }}>

        {/* HERO */}
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(2.5rem,5vw,4rem)',
            fontWeight: 900,
            marginBottom: 20
          }}>
            Make Youth Voices <em>Heard</em>
          </h1>

          <p style={{
            fontSize: '1.2rem',
            color: '#555',
            maxWidth: 700,
            margin: '0 auto',
            lineHeight: 1.8
          }}>
            Mahoko Friday News is a modern youth media platform in Rwanda,
            committed to telling real stories, sharing opportunities, and
            empowering the next generation.
          </p>
        </div>

        {/* GRID */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
          gap: 30,
          marginBottom: 60
        }}>
          {[
            ['📰', 'Our Mission', 'We amplify youth voices and connect them to real opportunities.'],
            ['🌍', 'Our Reach', 'We report across Rwanda and Africa on key issues affecting young people.'],
            ['🎯', 'Our Values', 'Integrity, truth, and impact guide everything we publish.'],
            ['🤝', 'Our Community', 'A growing network of readers, writers, and change-makers.'],
          ].map(([icon, title, text]) => (
            <div key={title} style={{
              padding: 25,
              background: '#f8f8f8',
              border: '1px solid #eee'
            }}>
              <div style={{ fontSize: '2rem' }}>{icon}</div>
              <h3 style={{ marginTop: 10 }}>{title}</h3>
              <p style={{ color: '#555' }}>{text}</p>
            </div>
          ))}
        </div>

        {/* CONTACT STRIP */}
        <div style={{
          background: '#111',
          color: '#fff',
          padding: 40,
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 40
        }}>
          <div>
            <h2>Get in Touch</h2>
            <p style={{ color: '#ccc' }}>
              Have a story tip or want to collaborate? Let’s build something meaningful together.
            </p>
            <p>📧 mfnyouthvoice@gmail.com</p>
            <p>📞 +250 787426258</p>
          </div>

          <div>
            <h2>Our Story</h2>
            <p style={{ color: '#ccc' }}>
              Founded in Rubavu, MFN is growing into a trusted youth media platform in Rwanda.
            </p>
          </div>
        </div>

      </div>
      <CookieBanner />
    </PublicLayout>
  );
}


// ─── CONTACT PAGE ─────────────────────────────────────────────────────────────
export function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <PublicLayout>
      <div style={{ maxWidth: 700, margin: '0 auto', padding: 60 }}>

        <h1 style={{ marginBottom: 20 }}>Contact Us</h1>

        {sent ? (
          <p>✅ Your message has been sent successfully.</p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <input placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea rows={5} placeholder="Your Message" required />
            <button style={{ padding: 12, background: '#c0392b', color: '#fff', border: 'none' }}>
              Send Message
            </button>
          </form>
        )}

      </div>
      <CookieBanner />
    </PublicLayout>
  );
}


// ─── SUBSCRIBE PAGE ───────────────────────────────────────────────────────────
export function SubscribePage() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  return (
    <PublicLayout>
      <div style={{ textAlign: 'center', padding: 60 }}>

        <h1>Stay Updated</h1>
        <p>Get the latest youth news and opportunities directly in your inbox.</p>

        {success ? (
          <p>🎉 You are subscribed!</p>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); setSuccess(true); }}>
            <input
              type="email"
              placeholder="Enter your email"
              required
              style={{ padding: 10, marginRight: 10 }}
            />
            <button style={{ padding: 10, background: '#c0392b', color: '#fff', border: 'none' }}>
              Subscribe
            </button>
          </form>
        )}

      </div>
      <CookieBanner />
    </PublicLayout>
  );
}


// ─── PRIVACY PAGE ─────────────────────────────────────────────────────────────
export function PrivacyPage() {
  return (
    <PublicLayout>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: 60 }}>

        <h1>Privacy Policy</h1>

        <p>
          We respect your privacy and are committed to protecting your personal information.
        </p>

        <h3>Cookies and Advertising</h3>
        <p>
          Mahoko Friday News uses cookies to improve your experience.
          We also use Google AdSense, which may use cookies to show ads
          based on your visits to this and other websites.
        </p>

      </div>
      <CookieBanner />
    </PublicLayout>
  );
}
